import Service from '../../others/service/service';
import logo_contrats from '../../../assets/images/mes-contrats.png';
import logo_factures from '../../../assets/images/mes-factures.png';
import logo_conso from '../../../assets/images/mes-consos.png';
import logo_requests from '../../../assets/images/mes-demandes.png';
import logo_demarches_en_ligne from '../../../assets/images/refonte/demarches-en-ligne.png';
import logo_contact from '../../../assets/images/refonte/contact.jpeg';
import logo_emmenagement from '../../../assets/images/emmenage-co.png';
import { alpha, Box, Button, Container, Grid, Typography } from '@mui/material';
import './home.ui.scss';
import React, { Fragment } from 'react';
import { PageContentDto } from '../../../services/dtos/page-content.dto';
import parse from 'html-react-parser';
import { roboto } from '../../../theme';
import LoginForm from '../../forms/login/login.form';
import { AuthDto } from '../../../services/dtos/auth.dto';
import { CarrouselCustom } from '../../commun/carrousel-custom';
import { env } from '../../../env';

/**
 * Composant pour la page d'accueil.
 *
 * Il contient deux affichages :
 *  - Si l'utilisateur est connecté
 *  - Si l'utilisateur n'est pas connecté
 *
 * @constructor
 */
export default function HomeUi(props: {
    params?: PageContentDto;
    isAuth: boolean;
    loading: boolean;
    hasContract?: boolean;
    handlerConnectionSubmit: (e: AuthDto) => Promise<void>;
    validate: boolean;
}) {
    let gridService;
    let images: string[] = [];
    if (env.REACT_APP_THEME === 'sddea') {
        images = [
            '/sddea/slider/slider-ac.jpg',
            '/sddea/slider/slider-ac-2.jpg',
            '/sddea/slider/slider-eau-vive.jpg',
            '/sddea/slider/slider-res-troyes.jpg',
            '/sddea/slider/slider-rst-2.jpg',
            '/sddea/slider/slider-rst-3.jpg',
            '/sddea/slider/slider-rts-1.jpg',
        ];
    } else if (env.REACT_APP_THEME === 'tcm') {
        images = ['/tcm/slider/steu1.jpg', '/tcm/slider/steu2.jpg', '/tcm/slider/steu3.jpg', '/tcm/slider/steu4.jpg'];
    }
    const homeServices = 'home-services';
    // Gestion de la grille de boutons en fonction de la connexion ou non de l'utilisateur et de s'il possède un contrat rattaché
    if (props.isAuth) {
        if (props.hasContract) {
            // Grille de boutons de la page d'accueil
            gridService = (
                <>
                    {/* Bouton d'accès aux contrats */}
                    <Grid className="gridCard" item xs={12} md={2}>
                        <Service
                            title="J'emménage"
                            href="/j-emmenage"
                            img={logo_emmenagement}
                            styleName={homeServices}
                        />
                    </Grid>
                    {/* Bouton d'accès aux contrats */}
                    <Grid className="gridCard" item xs={12} md={2}>
                        <Service
                            title="Mes contrats"
                            href="/mes-contrats"
                            img={logo_contrats}
                            styleName={homeServices}
                        />
                    </Grid>

                    {/* Bouton d'accès aux factures */}
                    <Grid className="gridCard" item xs={12} md={2}>
                        <Service
                            title="Mes factures"
                            href="/mes-factures"
                            img={logo_factures}
                            styleName={homeServices}
                        />
                    </Grid>
                    {/* Bouton d'accès aux demandes */}
                    <Grid className="gridCard" item xs={12} md={2}>
                        <Service
                            title="Mes demandes"
                            href="/mes-demandes"
                            img={logo_requests}
                            styleName={homeServices}
                        />
                    </Grid>
                    {/* Bouton d'accès aux consommations */}
                    <Grid className="gridCard" item xs={12} md={2}>
                        <Service
                            title="Mes consommations"
                            href="/mes-consommations"
                            img={logo_conso}
                            styleName={homeServices}
                        />
                    </Grid>
                </>
            );
        } else {
            // Si user sans contrats, affiche le bouton de rattachement d'un contrat
            gridService = props.hasContract === false && (
                <>
                    {/* Bouton d'accès aux contrats */}
                    <Grid className="gridCard" item xs={12} md={5}>
                        <Service
                            title="J'emménage"
                            href="/j-emmenage"
                            img={logo_emmenagement}
                            styleName={homeServices}
                        />
                    </Grid>
                    <Grid className="gridCard" item xs={12} md={5}>
                        <Service
                            title="Ajouter un contrat"
                            href="/rattacher-un-contrat"
                            img={logo_contrats}
                            styleName={homeServices}
                        />
                    </Grid>
                </>
            );
        }
    } else {
        // Si user pas connecté, affichage du bouton de connexion
        gridService = (
            <Fragment>
                <Grid className="gridCard" item xs={12} md={3}>
                    <Service
                        title="Démarches en ligne"
                        href="/demarches-en-ligne"
                        description={
                            <Typography
                                variant="body1"
                                color="text.primary"
                                sx={{ textAlign: 'center', fontSize: 'small', margin: '5px' }}
                            >
                                Je paie ma facture, je réalise mon relevé de compteur ou bien signale
                                <br />
                                un emménagement
                                <Button variant="contained" className={'cardButton'}>
                                    je réalise mes démarches
                                </Button>
                            </Typography>
                        }
                        img={logo_demarches_en_ligne}
                        styleName={'home'}
                    />
                </Grid>
                <Grid className="gridCard" item xs={12} md={3}>
                    <Service
                        title="Contact"
                        href="/contactez-nous"
                        img={logo_contact}
                        styleName={'home'}
                        description={
                            <Typography
                                variant="body1"
                                color="text.primary"
                                sx={{ textAlign: 'center', fontSize: 'small', margin: '5px' }}
                            >
                                J'envoie un email au service de la Relation aux Usagers en me munissant
                                <br />
                                de ma dernière facture si possible
                                <Button className={'cardButton'} variant="contained">
                                    J'envoie un email
                                </Button>
                            </Typography>
                        }
                    />
                </Grid>
                <Grid item xs={12} md={4} marginTop={-15} display={{ xs: 'none', md: 'block' }}>
                    <LoginForm handlerConnectionSubmit={props.handlerConnectionSubmit} validate={props.validate} />
                </Grid>
            </Fragment>
        );
    }

    // Création de la page
    return (
        <Container disableGutters className={'containerHome'} maxWidth={false}>
            {!props.loading && (
                <Box
                    className={'textHome'}
                    sx={{
                        backgroundColor: alpha('#f2f5f6', 0.5),
                        borderRadius: '20px',
                        fontFamily: roboto,
                        marginLeft: '5em',
                        fontWeight: 'inherit !important',
                        width: '61em',
                        marginTop: '6em',
                        padding: '1em',
                        position: 'absolute',
                        zIndex: 5,
                    }}
                >
                    {/*Partie titre et content récupérée via API*/}
                    <Typography variant="h4" paddingLeft={'10px'}>
                        {props.params?.title}
                    </Typography>
                    <Typography component="div" paddingLeft={'10px'}>
                        {props.params?.content ? parse(props.params.content) : ''}
                    </Typography>
                </Box>
            )}
            <CarrouselCustom images={images} />

            <Grid
                container
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    marginTop: '-5em',
                    paddingLeft: '2em',
                    paddingRight: '2em',
                }}
                spacing={5}
                columns={10}
            >
                {/* Récupération des services déclarés plus haut */}
                {gridService}
            </Grid>
        </Container>
    );
}
